<!-- <p>post-reports works!</p> -->
<div class="w-full h-full bg-white rounded-lg shadow-lg">
  <div
    class="p-4 sm:p-6 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50"
  >
    <div
      class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 sm:mb-6 gap-4"
    >
      <h2 class="text-xl sm:text-2xl font-bold text-gray-900">
        Community Dashboard
      </h2>
      <div
        class="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full sm:w-auto"
      >
        <select
          [(ngModel)]="selectedTimeFilter"
          (change)="applyTimeFilter()"
          class="px-3 py-2 border border-gray-300 rounded-lg text-sm w-full sm:w-auto"
        >
          <option value="all">All Time</option>
          <option value="today">Today</option>
          <option value="week">This Week</option>
          <option value="month">This Month</option>
        </select>

        <div class="flex items-center gap-2 text-sm text-gray-600">
          <mat-icon class="w-4 h-4" aria-hidden="true"> history </mat-icon>
          Last updated: {{ getLastUpdatedTime() }}
        </div>
      </div>
    </div>

    <div
      class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4 mb-4 sm:mb-6"
    >
      <div
        class="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-gray-200"
      >
        <div class="flex items-center justify-between">
          <div class="p-1 sm:p-2">
            <p class="text-xs sm:text-sm font-medium text-gray-600">
              Total Posts
            </p>
            <p class="text-xl sm:text-2xl font-bold text-gray-900">
              {{ getTotalPosts() }}
            </p>
            <p class="text-xs text-gray-500">{{ getPostsGrowth() }}</p>
          </div>
          <div class="p-1 sm:p-2 ml-1 bg-blue-100 rounded-lg">
            <mat-icon
              class="w-4 h-4 sm:w-5 sm:h-5 text-blue-600"
              aria-hidden="true"
            >
              description
            </mat-icon>
          </div>
        </div>
      </div>

      <div
        class="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-gray-200"
      >
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600">Pending</p>
            <p class="text-xl sm:text-2xl font-bold text-yellow-600">
              {{ pendingApprovalPosts.length }}
            </p>
            <p class="text-xs text-gray-500">{{ getPendingGrowth() }}</p>
          </div>
          <div class="p-1 sm:p-2 bg-yellow-100 rounded-lg">
            <mat-icon
              class="w-4 h-4 sm:w-5 sm:h-5 text-yellow-600"
              aria-hidden="true"
            >
              schedule
            </mat-icon>
          </div>
        </div>
      </div>

      <div
        class="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-gray-200"
      >
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600">Reports</p>
            <p class="text-xl sm:text-2xl font-bold text-red-600">
              {{ getTotalReports() }}
            </p>
            <p class="text-xs text-gray-500">{{ getReportsGrowth() }}</p>
          </div>
          <div class="p-1 sm:p-2 bg-red-100 rounded-lg">
            <mat-icon
              class="w-4 h-4 sm:w-5 sm:h-5 text-red-600"
              aria-hidden="true"
            >
              error
            </mat-icon>
          </div>
        </div>
      </div>

      <div
        class="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-gray-200"
      >
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600">Approved</p>
            <p class="text-xl sm:text-2xl font-bold text-green-600">
              {{ getApprovedCount() }}
            </p>
            <p class="text-xs text-gray-500">{{ getApprovedGrowth() }}</p>
          </div>
          <div class="p-1 sm:p-2 bg-green-100 rounded-lg">
            <mat-icon
              class="w-4 h-4 sm:w-5 sm:h-5 text-green-600"
              aria-hidden="true"
            >
              check_circle
            </mat-icon>
          </div>
        </div>
      </div>
      <div
        class="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-gray-200"
      >
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600">Rejected</p>
            <p class="text-xl sm:text-2xl font-bold text-orange-600">
              {{ rejectedPosts.length }}
            </p>
            <p class="text-xs text-gray-500">{{ getRejectedGrowth() }}</p>
          </div>
          <div class="p-1 sm:p-2 bg-orange-100 rounded-lg">
            <mat-icon
              class="w-4 h-4 sm:w-5 sm:h-5 text-orange-600"
              aria-hidden="true"
            >
              flag
            </mat-icon>
          </div>
        </div>
      </div>

      <div
        class="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-gray-200"
      >
        <div class="flex items-center justify-between">
          <div>
            <p class="text-xs sm:text-sm font-medium text-gray-600">Flagged</p>
            <p class="text-xl sm:text-2xl font-bold text-orange-600">
              {{ flaggedPosts.length }}
            </p>
            <p class="text-xs text-gray-500">{{ getFlaggedGrowth() }}</p>
          </div>
          <div class="p-1 sm:p-2 bg-orange-100 rounded-lg">
            <mat-icon
              class="w-4 h-4 sm:w-5 sm:h-5 text-orange-600"
              aria-hidden="true"
            >
              flag
            </mat-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap gap-2 sm:gap-3">
      <button
        (click)="toggleSection('pending')"
        [class]="getButtonClass('pending')"
        class="flex items-center gap-2 px-3 py-2 rounded-lg transition-colors duration-200 ease-in-out text-sm w-full sm:w-auto justify-center"
      >
        <mat-icon class="w-4 h-4" aria-hidden="true"> schedule </mat-icon>
        <div class="flex flex-col items-start">
          <span class="font-medium">Pending Approval</span>
          <span class="text-xs opacity-75">{{ getPendingDetails() }}</span>
        </div>
        <span
          class="bg-white bg-opacity-30 px-2 py-1 rounded-full text-xs font-bold"
        >
          {{ pendingApprovalPosts.length }}
        </span>
      </button>

      <button
        (click)="toggleSection('reports')"
        [class]="getButtonClass('reports')"
        class="flex items-center gap-2 px-3 py-2 rounded-lg transition-colors duration-200 ease-in-out text-sm w-full sm:w-auto justify-center"
      >
        <mat-icon class="w-4 h-4" aria-hidden="true"> description </mat-icon>
        <div class="flex flex-col items-start">
          <span class="font-medium">Reports & Reviews</span>
          <span class="text-xs opacity-75">{{ getReportsDetails() }}</span>
        </div>
        <span
          class="bg-white bg-opacity-30 px-2 py-1 rounded-full text-xs font-bold"
        >
          {{ getTotalReports() }}
        </span>
      </button>

      <button
        (click)="toggleSection('flagged')"
        [class]="getButtonClass('flagged')"
        class="flex items-center gap-2 px-3 py-2 rounded-lg transition-colors duration-200 ease-in-out text-sm w-full sm:w-auto justify-center"
      >
        <mat-icon class="w-4 h-4" aria-hidden="true"> flag </mat-icon>
        <div class="flex flex-col items-start">
          <span class="font-medium">Flagged Content</span>
          <span class="text-xs opacity-75">{{ getFlaggedDetails() }}</span>
        </div>
        <span
          class="bg-white bg-opacity-30 px-2 py-1 rounded-full text-xs font-bold"
        >
          {{ flaggedPosts.length }}
        </span>
      </button>

      <button
        (click)="toggleSection('analytics')"
        [class]="getButtonClass('analytics')"
        class="flex items-center gap-2 px-3 py-2 rounded-lg transition-colors duration-200 ease-in-out text-sm w-full sm:w-auto justify-center"
      >
        <mat-icon class="w-4 h-4" aria-hidden="true"> bar_chart </mat-icon>
        <div class="flex flex-col items-start">
          <span class="font-medium">Analytics</span>
          <span class="text-xs opacity-75">Performance insights</span>
        </div>
      </button>
    </div>
  </div>

  <div class="p-4 sm:p-6">
    <div *ngIf="activeSection === 'pending'">
      <div
        class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2"
      >
        <h3 class="text-lg sm:text-xl font-semibold text-gray-800">
          Posts Pending Approval
        </h3>
        <div class="flex items-center gap-2 w-full sm:w-auto justify-end">
          <label for="pendingSort" class="text-sm text-gray-600"
            >Sort by:</label
          >
          <select
            id="pendingSort"
            [(ngModel)]="pendingSortBy"
            (change)="sortPendingPosts()"
            class="px-3 py-2 border border-gray-300 rounded-lg text-sm w-full sm:w-auto"
          >
            <option value="date">Date</option>
            <option value="priority">Priority</option>
            <option value="author">Author</option>
          </select>
        </div>
      </div>

      <div *ngIf="pendingApprovalPosts.length > 0; else noPendingPosts">
        <!-- Desktop Table View (hidden on mobile) with max 3 posts + scroll -->
        <div class="hidden md:block">
          <div
            class="max-h-[400px] overflow-y-auto rounded-lg border border-gray-200"
          >
            <table class="min-w-full bg-white">
              <thead class="bg-gray-50 border-b border-gray-200 sticky top-0">
                <tr>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Post ID
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Content
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Author
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Submitted
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Status
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Attachments
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <tr
                  *ngFor="
                    let post of pendingApprovalPosts;
                    trackBy: trackByPostId
                  "
                >
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {{ post.postId.split("-")[0] }}
                  </td>
                  <td class="px-6 py-4 max-w-xs truncate text-sm text-gray-900">
                    {{ post.postDescription }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                    {{ post.postUsername }} ({{ getUserRole(post.postUserId) }})
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                    {{ formatDate(post.postAddDate) }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <span
                      [class]="
                        'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                        getPostStatusClass(post)
                      "
                    >
                      {{ getPostStatusText(post) }}
                    </span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                    {{ getAttachmentCount(post) }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <button
                      (click)="openApprovalModal(post)"
                      class="flex items-center gap-1 text-blue-600 hover:text-blue-900 font-medium"
                    >
                      <mat-icon>rate_review</mat-icon>
                      Review Post
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Mobile Card View (hidden on desktop) with max 2 posts + scroll -->
        <div class="md:hidden">
          <div class="max-h-[500px] overflow-y-auto space-y-3">
            <div
              *ngFor="let post of pendingApprovalPosts; trackBy: trackByPostId"
              class="bg-white rounded-lg shadow-sm border border-gray-200 p-3"
            >
              <!-- Compact Post Header -->
              <div class="flex justify-between items-center mb-2">
                <span class="text-sm font-medium text-gray-900">
                  #{{ post.postId.split("-")[0] }}
                </span>
                <span
                  [class]="
                    'px-2 py-1 text-xs font-semibold rounded-full ' +
                    getPostStatusClass(post)
                  "
                >
                  {{ getPostStatusText(post) }}
                </span>
              </div>

              <!-- Post Content -->
              <div class="mb-2">
                <p class="text-sm text-gray-900 line-clamp-2">
                  {{ post.postDescription }}
                </p>
              </div>

              <!-- Compact Info Row -->
              <div
                class="grid grid-cols-2 gap-2 text-xs text-gray-600 mb-3 pt-2 border-t border-gray-100"
              >
                <div>
                  <span class="font-medium">{{ post.postUsername }}</span>
                  <div class="text-gray-500">
                    ({{ getUserRole(post.postUserId) }})
                  </div>
                </div>
                <div class="text-right">
                  <div>{{ formatDate(post.postAddDate) }}</div>
                  <div class="text-gray-500">
                    {{ getAttachmentCount(post) }} files
                  </div>
                </div>
              </div>

              <!-- Compact Action Button -->
              <button
                (click)="openApprovalModal(post)"
                class="w-full flex items-center justify-center gap-1 bg-blue-50 hover:bg-blue-100 text-blue-700 font-medium py-2 px-3 rounded-md transition-colors duration-200 text-sm"
              >
                <mat-icon class="text-base">rate_review</mat-icon>
                Review
              </button>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noPendingPosts>
        <p class="text-center text-gray-500 py-8">
          No posts pending approval at the moment.
        </p>
      </ng-template>
    </div>

    <!-- Approval Modal Template -->
    <div
      *ngIf="showApprovalModal && selectedPostForModal"
      class="fixed inset-0 z-50 overflow-y-auto"
      (click)="closeModal()"
    >
      <!-- Backdrop -->
      <div
        class="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
      ></div>

      <!-- Modal Container - Different positioning for mobile/desktop -->
      <div
        class="flex min-h-full items-end sm:items-center justify-center p-0 sm:p-4"
      >
        <div
          class="relative transform overflow-hidden rounded-t-xl sm:rounded-xl bg-white shadow-xl transition-all w-full sm:max-w-2xl max-h-[90vh] sm:max-h-[85vh]"
          [ngClass]="{ 'scale-100 opacity-100': showApprovalModal }"
          (click)="$event.stopPropagation()"
          style="font-family: 'Inter', sans-serif"
        >
          <!-- Mobile Layout -->
          <div class="sm:hidden">
            <!-- Mobile Handle Bar -->
            <div class="flex justify-center pt-2 pb-1">
              <div class="w-8 h-1 bg-gray-300 rounded-full"></div>
            </div>

            <!-- Mobile Header -->
            <div class="flex justify-between items-center px-4 py-3 border-b">
              <h2 class="text-lg font-bold text-gray-800">Review Post</h2>
              <button
                (click)="closeModal()"
                class="p-1 hover:bg-gray-100 rounded-full transition-colors duration-200"
              >
                <mat-icon class="h-5 w-5 text-gray-500" aria-hidden="true">
                  close
                </mat-icon>
              </button>
            </div>

            <!-- Mobile Content -->
            <div class="overflow-y-auto max-h-[calc(90vh-140px)] px-4 py-3">
              <div class="space-y-3 text-gray-700 text-sm">
                <!-- Compact Post Info Card -->
                <div class="bg-gray-50 rounded-lg p-3">
                  <div class="flex justify-between items-start mb-2">
                    <span class="text-xs font-medium text-gray-600">
                      ID: {{ selectedPostForModal.postId.split("-")[0] }}
                    </span>
                    <span
                      [class]="
                        'px-2 py-1 text-xs font-semibold rounded-full ' +
                        getPostStatusClass(selectedPostForModal)
                      "
                    >
                      {{ getPostStatusText(selectedPostForModal) }}
                    </span>
                  </div>
                  <p class="text-sm text-gray-900 mb-2 leading-relaxed">
                    {{ selectedPostForModal.postDescription }}
                  </p>
                  <div class="grid grid-cols-2 gap-2 text-xs text-gray-600">
                    <div>
                      <span class="font-medium">Author:</span><br />
                      <span class="text-gray-900">{{
                        selectedPostForModal.postUsername
                      }}</span
                      ><br />
                      <span class="text-gray-500"
                        >({{
                          getUserRole(selectedPostForModal.postUserId)
                        }})</span
                      >
                    </div>
                    <div class="text-right">
                      <span class="font-medium">Submitted:</span><br />
                      <span class="text-gray-900">{{
                        formatDate(selectedPostForModal.postAddDate)
                      }}</span>
                    </div>
                  </div>
                </div>

                <!-- Attachments Section -->
                <div
                  *ngIf="
                    selectedPostForModal.postAttachment &&
                    selectedPostForModal.postAttachment.length > 0
                  "
                >
                  <p class="font-semibold text-sm mb-2">
                    Attachments ({{
                      selectedPostForModal.postAttachment.length
                    }})
                  </p>
                  <div class="grid grid-cols-4 gap-2">
                    <div
                      *ngFor="
                        let attachment of selectedPostForModal.postAttachment;
                        let i = index
                      "
                      class="aspect-square bg-gray-100 rounded-md flex items-center justify-center overflow-hidden text-xs text-gray-600 border border-gray-200"
                    >
                      <img
                        *ngIf="attachment?.type === 'image'"
                        [src]="attachment.url"
                        alt="Attachment {{ i + 1 }}"
                        class="object-cover w-full h-full"
                      />
                      <span
                        *ngIf="attachment.type !== 'image'"
                        class="text-center p-1 text-xs"
                        >{{ attachment.type?.toUpperCase() || "FILE" }}</span
                      >
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="
                    !selectedPostForModal.postAttachment ||
                    selectedPostForModal.postAttachment.length === 0
                  "
                >
                  <p class="text-sm text-gray-500">No attachments</p>
                </div>
              </div>
            </div>

            <!-- Mobile Actions -->
            <div class="p-4 border-t bg-gray-50 space-y-2">
              <div class="grid grid-cols-2 gap-2">
                <button
                  (click)="confirmApproval()"
                  class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 transition-all duration-200 text-sm font-medium"
                >
                  Approve
                </button>
                <button
                  (click)="confirmRejection()"
                  class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 transition-all duration-200 text-sm font-medium"
                >
                  Reject
                </button>
              </div>
              <button
                (click)="closeModal()"
                class="w-full px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50 transition-all duration-200 text-sm font-medium"
              >
                Close
              </button>
            </div>
          </div>

          <!-- Desktop Layout -->
          <div class="hidden sm:block p-6">
            <div class="flex justify-between items-center border-b pb-4 mb-4">
              <h2 class="text-xl font-bold text-gray-800">Review Post</h2>
              <button
                (click)="closeModal()"
                class="text-gray-500 hover:text-gray-700 transition-colors duration-200"
              >
                <mat-icon class="h-6 w-6" aria-hidden="true"> close </mat-icon>
              </button>
            </div>

            <div class="max-h-[60vh] overflow-y-auto">
              <div class="space-y-4 text-gray-700 text-sm">
                <div>
                  <p class="font-semibold">Post ID:</p>
                  <p>{{ selectedPostForModal.postId }}</p>
                </div>
                <div>
                  <p class="font-semibold">Content:</p>
                  <p class="whitespace-pre-wrap break-words">
                    {{ selectedPostForModal.postDescription }}
                  </p>
                </div>
                <div>
                  <p class="font-semibold">Author:</p>
                  <p>
                    {{ selectedPostForModal.postUsername }} ({{
                      getUserRole(selectedPostForModal.postUserId)
                    }})
                  </p>
                </div>
                <div>
                  <p class="font-semibold">Submitted On:</p>
                  <p>{{ formatDate(selectedPostForModal.postAddDate) }}</p>
                </div>
                <div>
                  <p class="font-semibold">Current Status:</p>
                  <span
                    [class]="
                      'px-3 py-1 inline-flex text-sm leading-5 font-semibold rounded-full ' +
                      getPostStatusClass(selectedPostForModal)
                    "
                  >
                    {{ getPostStatusText(selectedPostForModal) }}
                  </span>
                </div>
                <div
                  *ngIf="
                    selectedPostForModal.postAttachment &&
                    selectedPostForModal.postAttachment.length > 0
                  "
                >
                  <p class="font-semibold">
                    Attachments ({{
                      selectedPostForModal.postAttachment.length
                    }}):
                  </p>
                  <div class="flex flex-wrap gap-2 mt-2">
                    <div
                      *ngFor="
                        let attachment of selectedPostForModal.postAttachment;
                        let i = index
                      "
                      class="w-20 h-14 bg-gray-100 rounded-md flex items-center justify-center overflow-hidden text-xs text-gray-600 border border-gray-200"
                    >
                      <img
                        *ngIf="attachment?.type === 'image'"
                        [src]="attachment.url"
                        alt="Attachment {{ i + 1 }}"
                        class="object-cover w-full h-full"
                      />
                      <span
                        *ngIf="attachment.type !== 'image'"
                        class="text-center p-1"
                        >{{ attachment.type?.toUpperCase() || "FILE" }}</span
                      >
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="
                    !selectedPostForModal.postAttachment ||
                    selectedPostForModal.postAttachment.length === 0
                  "
                >
                  <p class="font-semibold">Attachments:</p>
                  <p>No attachments.</p>
                </div>
              </div>
            </div>

            <div
              class="mt-6 flex flex-col sm:flex-row justify-end gap-3 border-t pt-4"
            >
              <button
                (click)="confirmApproval()"
                class="w-full sm:w-auto px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 transition-all duration-200"
              >
                Approve
              </button>
              <button
                (click)="confirmRejection()"
                class="w-full sm:w-auto px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 transition-all duration-200"
              >
                Reject
              </button>
              <button
                (click)="closeModal()"
                class="w-full sm:w-auto px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50 transition-all duration-200"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="activeSection === 'reports'">
      <div
        class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2"
      >
        <h3 class="text-lg sm:text-xl font-semibold text-gray-800">
          Reports & Reviews
        </h3>
        <div
          class="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full sm:w-auto justify-end"
        >
          <div class="flex items-center gap-2 w-full sm:w-auto">
            <label for="reportStatusFilter" class="text-sm text-gray-600"
              >Filter by Status:</label
            >
            <select
              id="reportStatusFilter"
              [(ngModel)]="reportStatusFilter"
              (change)="filterReports()"
              class="px-3 py-2 border border-gray-300 rounded-lg text-sm w-full sm:w-auto"
            >
              <option value="all">All</option>
              <option value="PENDING">Pending</option>
              <option value="REVIEWED">Reviewed</option>
              <option value="RESOLVED">Resolved</option>
              <option value="DISMISSED">Dismissed</option>
            </select>
          </div>
          <div class="flex items-center gap-2 w-full sm:w-auto">
            <label for="reportSort" class="text-sm text-gray-600"
              >Sort by:</label
            >
            <select
              id="reportSort"
              [(ngModel)]="reportSortBy"
              (change)="sortReports()"
              class="px-3 py-2 border border-gray-300 rounded-lg text-sm w-full sm:w-auto"
            >
              <option value="date">Date</option>
              <option value="severity">Severity</option>
              <option value="status">Status</option>
            </select>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div
          class="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-gray-200"
        >
          <p class="text-xs sm:text-sm font-medium text-gray-600">
            Critical Reports
          </p>
          <p class="text-xl sm:text-2xl font-bold text-red-600">
            {{ getCriticalReportsCount() }}
          </p>
        </div>
        <div
          class="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-gray-200"
        >
          <p class="text-xs sm:text-sm font-medium text-gray-600">
            Pending Reviews
          </p>
          <p class="text-xl sm:text-2xl font-bold text-yellow-600">
            {{ getPendingReportsCount() }}
          </p>
        </div>
        <div
          class="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-gray-200"
        >
          <p class="text-xs sm:text-sm font-medium text-gray-600">
            Avg. Response Time
          </p>
          <p class="text-xl sm:text-2xl font-bold text-blue-600">
            {{ getAvgResponseTime() }}
          </p>
        </div>
      </div>
      <div *ngIf="getFilteredReportedPosts().length > 0; else noReports">
        <!-- Mobile: Card Layout -->
        <div class="block sm:hidden space-y-4">
          <div
            *ngFor="
              let post of getFilteredReportedPosts();
              trackBy: trackByPostId
            "
            class="bg-white rounded-lg shadow-sm border border-gray-200 p-4"
          >
            <!-- Card Header -->
            <div class="flex justify-between items-start mb-3">
              <div class="flex-1">
                <h4 class="text-sm font-semibold text-gray-900 mb-1">
                  Post ID: {{ post.postId.split("-")[0] }}
                </h4>
                <p class="text-xs text-gray-600 line-clamp-2 leading-relaxed">
                  {{ post.postDescription }}
                </p>
              </div>
              <div class="ml-3 flex-shrink-0">
                <span
                  [class]="
                    'px-2 py-1 inline-flex text-xs leading-4 font-semibold rounded-full ' +
                    getPostReportOverallStatusClass(post)
                  "
                >
                  {{ getPostReportOverallStatusText(post) }}
                </span>
              </div>
            </div>
            <!-- Card Stats -->
            <div class="grid grid-cols-3 gap-3 mb-4">
              <div class="text-center">
                <div class="text-lg font-bold text-blue-600">
                  {{ post.postReports?.length || 0 }}
                </div>
                <div class="text-xs text-gray-500">Reports</div>
              </div>
              <div class="text-center">
                <span
                  [class]="
                    'px-2 py-1 inline-flex text-xs leading-4 font-semibold rounded-full ' +
                    getReportSeverityClass(post)
                  "
                >
                  {{ getReportSeverity(post) }}
                </span>
                <div class="text-xs text-gray-500 mt-1">Severity</div>
              </div>
              <div class="text-center">
                <div class="text-sm font-medium text-gray-600">
                  {{ false || "N/A" }}
                </div>
                <div class="text-xs text-gray-500">Action</div>
              </div>
            </div>
            <!-- Card Action -->
            <div class="pt-3 border-t border-gray-100">
              <button
                (click)="openReportModal(post)"
                class="w-full flex items-center justify-center px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200 text-sm font-medium"
              >
                <mat-icon class="text-sm mr-2">visibility</mat-icon>
                View Reports ({{ post.postReports?.length || 0 }})
              </button>
            </div>
          </div>
        </div>
        <!-- Desktop: Table Layout -->
        <div class="hidden sm:block overflow-x-auto">
          <table
            class="min-w-full bg-white rounded-lg shadow-sm overflow-hidden"
          >
            <thead class="bg-gray-50 border-b border-gray-200">
              <tr>
                <th
                  class="px-3 py-2 sm:px-6 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Post ID
                </th>
                <th
                  class="px-3 py-2 sm:px-6 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Content Preview
                </th>
                <th
                  class="px-3 py-2 sm:px-6 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Total Reports
                </th>
                <th
                  class="px-3 py-2 sm:px-6 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Highest Severity
                </th>
                <th
                  class="px-3 py-2 sm:px-6 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Overall Status
                </th>
                <th
                  class="px-3 py-2 sm:px-6 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Post Action Taken
                </th>
                <th
                  class="px-3 py-2 sm:px-6 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200">
              <tr
                *ngFor="
                  let post of getFilteredReportedPosts();
                  trackBy: trackByPostId
                "
              >
                <td
                  class="px-3 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-900"
                >
                  {{ post.postId.split("-")[0] }}
                </td>
                <td
                  class="px-3 py-2 sm:px-6 sm:py-4 max-w-[150px] sm:max-w-xs truncate text-xs sm:text-sm text-gray-900"
                >
                  {{ post.postDescription }}
                </td>
                <td
                  class="px-3 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-600"
                >
                  {{ post.postReports?.length || 0 }}
                </td>
                <td class="px-3 py-2 sm:px-6 sm:py-4 whitespace-nowrap">
                  <span
                    [class]="
                      'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                      getReportSeverityClass(post)
                    "
                  >
                    {{ getReportSeverity(post) }}
                  </span>
                </td>
                <td class="px-3 py-2 sm:px-6 sm:py-4 whitespace-nowrap">
                  <span
                    [class]="
                      'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                      getPostReportOverallStatusClass(post)
                    "
                  >
                    {{ getPostReportOverallStatusText(post) }}
                  </span>
                </td>
                <td
                  class="px-3 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm text-gray-600"
                >
                  {{ false || "N/A" }}
                </td>
                <td
                  class="px-3 py-2 sm:px-6 sm:py-4 whitespace-nowrap text-xs sm:text-sm font-medium"
                >
                  <button
                    (click)="openReportModal(post)"
                    class="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200"
                  >
                    View Reports ({{ post.postReports?.length || 0 }})
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <ng-template #noReports>
        <p class="text-center text-gray-500 py-8">
          No reports found based on the current filters.
        </p>
      </ng-template>
    </div>
    <!-- Report Modal Template -->
    <!-- Mobile-Optimized Report Modal Template -->
    <div
      *ngIf="showReportModal && selectedPostForReportModal"
      class="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black bg-opacity-50 overflow-hidden"
      (click)="closeReportModal()"
    >
      <!-- Mobile: Bottom Sheet Style -->
      <div
        class="relative bg-white w-full h-[85vh] sm:h-auto sm:max-h-[90vh] sm:max-w-4xl sm:mx-auto rounded-t-2xl sm:rounded-lg shadow-xl transform transition-all duration-300 flex flex-col"
        [ngClass]="{ 'translate-y-0': showReportModal }"
        (click)="$event.stopPropagation()"
        style="font-family: 'Inter', sans-serif"
      >
        <!-- Mobile Handle Bar -->
        <div class="sm:hidden flex justify-center pt-2 pb-1">
          <div class="w-10 h-1 bg-gray-300 rounded-full"></div>
        </div>
        <!-- Header -->
        <div
          class="flex justify-between items-center border-b px-4 py-3 sm:px-8 sm:py-4 flex-shrink-0"
        >
          <h2 class="text-lg sm:text-2xl font-bold text-gray-800">
            Reports for Post
            {{ selectedPostForReportModal.postId.split("-")[0] }}
          </h2>
          <button
            (click)="closeReportModal()"
            class="text-gray-500 hover:text-gray-700 transition-colors duration-200 p-1"
          >
            <mat-icon class="text-xl sm:text-2xl">close</mat-icon>
          </button>
        </div>
        <!-- Scrollable Content -->
        <div class="flex-1 overflow-y-auto px-4 py-3 sm:px-8 sm:py-6">
          <!-- Post Details Card -->
          <div class="bg-gray-50 rounded-lg p-4 mb-4 sm:mb-6">
            <h3 class="text-base sm:text-lg font-semibold text-gray-800 mb-3">
              Post Details
            </h3>
            <!-- Mobile: Compact Layout -->
            <div class="space-y-3 sm:space-y-2">
              <div>
                <span
                  class="text-xs sm:text-sm font-semibold text-gray-600 block"
                  >Content:</span
                >
                <span
                  class="text-sm sm:text-base text-gray-700 whitespace-pre-wrap break-words"
                >
                  {{
                    selectedPostForReportModal.postDescription | slice : 0 : 150
                  }}
                  {{
                    selectedPostForReportModal.postDescription.length > 150
                      ? "..."
                      : ""
                  }}
                </span>
              </div>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
                <div>
                  <span class="text-xs sm:text-sm font-semibold text-gray-600"
                    >Author:</span
                  >
                  <span class="text-sm sm:text-base text-gray-700 ml-1">
                    {{ selectedPostForReportModal.postUsername }}
                    ({{ getUserRole(selectedPostForReportModal.postUserId) }})
                  </span>
                </div>
                <div>
                  <span class="text-xs sm:text-sm font-semibold text-gray-600"
                    >Submitted:</span
                  >
                  <span class="text-sm sm:text-base text-gray-700 ml-1">
                    {{ formatDate(selectedPostForReportModal.postAddDate) }}
                  </span>
                </div>
              </div>
              <div>
                <span class="text-xs sm:text-sm font-semibold text-gray-600"
                  >Status:</span
                >
                <span
                  [class]="
                    'ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                    getPostStatusClass(selectedPostForReportModal)
                  "
                >
                  {{ getPostStatusText(selectedPostForReportModal) }}
                </span>
              </div>
            </div>
          </div>
          <!-- Individual Reports Section -->
          <div class="mb-6">
            <h3 class="text-base sm:text-lg font-semibold text-gray-800 mb-4">
              Reports ({{
                selectedPostForReportModal.postReports?.length || 0
              }})
            </h3>
            <div
              *ngIf="
                selectedPostForReportModal.postReports &&
                  selectedPostForReportModal.postReports.length > 0;
                else noIndividualReports
              "
            >
              <!-- Mobile: Card Layout -->
              <div class="block sm:hidden space-y-3">
                <div
                  *ngFor="
                    let report of selectedPostForReportModal.postReports;
                    trackBy: trackByReportId
                  "
                  class="bg-white border border-gray-200 rounded-lg p-3"
                >
                  <div class="flex justify-between items-start mb-2">
                    <span class="text-xs font-medium text-gray-500">
                      ID: {{ report.reportId.split("-")[0] }}
                    </span>
                    <span
                      [class]="
                        'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                        getReportStatusClass(report.reportStatus)
                      "
                    >
                      {{ report.reportStatus }}
                    </span>
                  </div>
                  <div class="space-y-2">
                    <div class="flex items-center gap-2">
                      <span
                        [class]="
                          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                          getReportReasonClass(report.reportReason)
                        "
                      >
                        {{ report.reportReason }}
                      </span>
                      <span
                        [class]="
                          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                          getReportSeverityClassForReport(report)
                        "
                      >
                        {{ getReportSeverityForReport(report) }}
                      </span>
                    </div>
                    <div class="text-xs text-gray-600">
                      By:
                      <span
                        class="text-blue-600 hover:underline cursor-pointer"
                        (click)="viewReporterProfile(report.reportedBy)"
                      >
                        {{ report.reportedByName }}
                      </span>
                      | {{ formatDate(report.reportDate) }}
                    </div>
                    <div
                      class="flex gap-2 mt-2"
                      *ngIf="
                        report.reportStatus === ReportStatus.PENDING ||
                        report.reportStatus === ReportStatus.REVIEWED
                      "
                    >
                      <button
                        (click)="
                          resolveReport(
                            selectedPostForReportModal,
                            report.reportId
                          )
                        "
                        class="flex-1 px-3 py-1 bg-green-600 text-white text-xs rounded hover:bg-green-700"
                      >
                        Resolve
                      </button>
                      <button
                        (click)="
                          dismissReport(
                            selectedPostForReportModal,
                            report.reportId
                          )
                        "
                        class="flex-1 px-3 py-1 bg-gray-600 text-white text-xs rounded hover:bg-gray-700"
                      >
                        Dismiss
                      </button>
                    </div>
                    <span
                      *ngIf="
                        report.reportStatus === ReportStatus.RESOLVED ||
                        report.reportStatus === ReportStatus.DISMISSED
                      "
                      class="text-xs text-gray-500"
                    >
                      No action needed
                    </span>
                  </div>
                </div>
              </div>
              <!-- Desktop: Table Layout -->
              <div class="hidden sm:block overflow-x-auto">
                <table
                  class="min-w-full bg-white rounded-lg shadow-sm border border-gray-200"
                >
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                      >
                        Report ID
                      </th>
                      <th
                        class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                      >
                        Reason
                      </th>
                      <th
                        class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                      >
                        Reported By
                      </th>
                      <th
                        class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                      >
                        Date
                      </th>
                      <th
                        class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                      >
                        Severity
                      </th>
                      <th
                        class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                      >
                        Status
                      </th>
                      <th
                        class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200">
                    <tr
                      *ngFor="
                        let report of selectedPostForReportModal.postReports;
                        trackBy: trackByReportId
                      "
                    >
                      <td class="px-3 py-2 text-xs text-gray-900">
                        {{ report.reportId.split("-")[0] }}
                      </td>
                      <td class="px-3 py-2 text-xs">
                        <span
                          [class]="
                            'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                            getReportReasonClass(report.reportReason)
                          "
                        >
                          {{ report.reportReason }}
                        </span>
                      </td>
                      <td
                        class="px-3 py-2 text-xs text-blue-600 hover:underline cursor-pointer"
                        (click)="viewReporterProfile(report.reportedBy)"
                      >
                        {{ report.reportedByName }}
                      </td>
                      <td class="px-3 py-2 text-xs text-gray-600">
                        {{ formatDate(report.reportDate) }}
                      </td>
                      <td class="px-3 py-2 text-xs">
                        <span
                          [class]="
                            'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                            getReportSeverityClassForReport(report)
                          "
                        >
                          {{ getReportSeverityForReport(report) }}
                        </span>
                      </td>
                      <td class="px-3 py-2 text-xs">
                        <span
                          [class]="
                            'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                            getReportStatusClass(report.reportStatus)
                          "
                        >
                          {{ report.reportStatus }}
                        </span>
                      </td>
                      <td class="px-3 py-2 text-xs font-medium">
                        <button
                          *ngIf="
                            report.reportStatus === ReportStatus.PENDING ||
                            report.reportStatus === ReportStatus.REVIEWED
                          "
                          (click)="
                            resolveReport(
                              selectedPostForReportModal,
                              report.reportId
                            )
                          "
                          class="text-green-600 hover:text-green-900 mr-2"
                        >
                          Resolve
                        </button>
                        <button
                          *ngIf="
                            report.reportStatus === ReportStatus.PENDING ||
                            report.reportStatus === ReportStatus.REVIEWED
                          "
                          (click)="
                            dismissReport(
                              selectedPostForReportModal,
                              report.reportId
                            )
                          "
                          class="text-gray-600 hover:text-gray-900"
                        >
                          Dismiss
                        </button>
                        <span
                          *ngIf="
                            report.reportStatus === ReportStatus.RESOLVED ||
                            report.reportStatus === ReportStatus.DISMISSED
                          "
                          class="text-gray-500"
                        >
                          No action needed
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <ng-template #noIndividualReports>
              <p class="text-center text-gray-500 py-4">
                No individual reports found for this post.
              </p>
            </ng-template>
          </div>
        </div>
        <!-- Fixed Action Bar -->
        <div class="border-t px-4 py-3 sm:px-8 sm:py-4 bg-white flex-shrink-0">
          <!-- Mobile: Stacked Layout -->
          <div
            *ngIf="false"
            class="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3"
          >
            <div class="grid grid-cols-2 gap-2 sm:contents">
              <button
                (click)="approvePost(selectedPostForReportModal)"
                class="px-4 py-2 sm:px-6 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 transition-all duration-200 text-sm sm:text-base"
              >
                <!-- <mat-icon class="text-sm mr-1">check</mat-icon> -->
                Approve
              </button>
              <button
                (click)="rejectPost(selectedPostForReportModal)"
                class="px-4 py-2 sm:px-6 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 transition-all duration-200 text-sm sm:text-base"
              >
                <!-- <mat-icon class="text-sm mr-1">close</mat-icon> -->
                Reject
              </button>
            </div>
            <button
              (click)="closeReportModal()"
              class="w-full sm:w-auto px-4 py-2 sm:px-6 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50 transition-all duration-200 text-sm sm:text-base mt-2 sm:mt-0"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Flagged Content Section -->

    <div *ngIf="activeSection === 'flagged'">
      <div
        class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2"
      >
        <h3 class="text-lg sm:text-xl font-semibold text-gray-800">
          Flagged Content
        </h3>
        <div class="flex items-center gap-2 w-full sm:w-auto justify-end">
          <label for="flaggedSort" class="text-sm text-gray-600"
            >Sort by:</label
          >
          <select
            id="flaggedSort"
            [(ngModel)]="flaggedSortBy"
            (change)="sortFlaggedPosts()"
            class="px-3 py-2 border border-gray-300 rounded-lg text-sm w-full sm:w-auto"
          >
            <option value="date">Date</option>
            <option value="flags">Number of Flags</option>
            <option value="status">Status</option>
          </select>
        </div>
      </div>
      <div *ngIf="getFilteredFlaggedPosts().length > 0; else noFlaggedPosts">
        <!-- Mobile Card View -->
        <div class="block sm:hidden space-y-4">
          <div
            *ngFor="
              let post of getFilteredFlaggedPosts();
              trackBy: trackByPostId
            "
            class="bg-white rounded-lg shadow-sm border border-gray-200 p-4"
          >
            <div class="flex justify-between items-start mb-3">
              <div class="flex-1">
                <div class="text-xs text-gray-500 mb-1">
                  ID: {{ post.postId.split("-")[0] }}
                </div>
                <div
                  class="text-sm font-medium text-gray-900 mb-2 line-clamp-2"
                >
                  {{ post.postDescription }}
                </div>
              </div>
              <span
                [class]="
                  'px-2 py-1 text-xs font-semibold rounded-full ml-2 ' +
                  getPostReportOverallStatusClass(post)
                "
              >
                {{ getPostReportOverallStatusText(post) }}
              </span>
            </div>
            <div class="grid grid-cols-2 gap-2 text-xs text-gray-600 mb-3">
              <div>
                <span class="font-medium">Author:</span>
                <div class="truncate">{{ post.postUsername }}</div>
              </div>
              <div>
                <span class="font-medium">Flags:</span>
                <div>{{ post.postReports?.length || 0 }}</div>
              </div>
              <div>
                <span class="font-medium">Last Flagged:</span>
                <div>{{ getLatestFlagDate(post) }}</div>
              </div>
            </div>
            <button
              (click)="openFlaggedPostModal(post)"
              class="w-full px-4 py-2 bg-blue-500 text-white text-sm rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200"
            >
              Manage Flags
            </button>
          </div>
        </div>
        <!-- Desktop Table View -->
        <div class="hidden sm:block overflow-x-auto">
          <table
            class="min-w-full bg-white rounded-lg shadow-sm overflow-hidden"
          >
            <thead class="bg-gray-50 border-b border-gray-200">
              <tr>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Post ID
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Content
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Author
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Flags
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Status
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Last Flagged
                </th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200">
              <tr
                *ngFor="
                  let post of getFilteredFlaggedPosts();
                  trackBy: trackByPostId
                "
              >
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{ post.postId.split("-")[0] }}
                </td>
                <td class="px-6 py-4 max-w-xs truncate text-sm text-gray-900">
                  {{ post.postDescription }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                  {{ post.postUsername }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                  {{ post.postReports?.length || 0 }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span
                    [class]="
                      'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                      getPostReportOverallStatusClass(post)
                    "
                  >
                    {{ getPostReportOverallStatusText(post) }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                  {{ getLatestFlagDate(post) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button
                    (click)="openFlaggedPostModal(post)"
                    class="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200"
                  >
                    Manage Flags
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <ng-template #noFlaggedPosts>
        <div class="text-center py-12">
          <div class="text-gray-400 mb-4">
            <mat-icon class="text-6xl">flag</mat-icon>
          </div>
          <p class="text-gray-500 text-lg">No flagged content at the moment.</p>
        </div>
      </ng-template>
    </div>

    <!-- Flagged Post Management Modal Template -->
    <div
      *ngIf="showFlaggedPostModal && selectedFlaggedPostForModal"
      class="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300"
      (click)="closeFlaggedPostModal()"
    >
      <!-- Mobile Bottom Sheet -->
      <div
        class="sm:hidden bg-white w-full max-h-[90vh] rounded-t-xl shadow-xl transform transition-transform duration-300 ease-out translate-y-0"
        (click)="$event.stopPropagation()"
      >
        <!-- Handle Bar -->
        <div class="flex justify-center pt-3 pb-2">
          <div class="w-12 h-1 bg-gray-300 rounded-full"></div>
        </div>
        <!-- Header -->
        <div class="flex justify-between items-center px-4 pb-3 border-b">
          <h2 class="text-lg font-bold text-gray-800">
            Manage Post {{ selectedFlaggedPostForModal.postId.split("-")[0] }}
          </h2>
          <button
            (click)="closeFlaggedPostModal()"
            class="text-gray-500 hover:text-gray-700 p-1"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <!-- Scrollable Content -->
        <div
          class="overflow-y-auto px-4 py-4"
          style="max-height: calc(75vh - 120px)"
        >
          <!-- Post Details Card -->
          <div class="bg-gray-50 rounded-lg p-3 mb-4">
            <h3 class="text-sm font-semibold text-gray-800 mb-2">
              Post Details
            </h3>
            <div class="space-y-2 text-sm">
              <div>
                <span class="font-medium text-gray-700">Content:</span>
                <p class="text-gray-600 mt-1 whitespace-pre-wrap break-words">
                  {{ selectedFlaggedPostForModal.postDescription }}
                </p>
              </div>
              <div class="grid grid-cols-2 gap-2 text-xs">
                <div>
                  <span class="font-medium text-gray-700">Author:</span>
                  <div class="text-gray-600">
                    {{ selectedFlaggedPostForModal.postUsername }}
                  </div>
                </div>
                <div>
                  <span class="font-medium text-gray-700">Total Flags:</span>
                  <div class="text-gray-600">
                    {{ selectedFlaggedPostForModal.postReports?.length || 0 }}
                  </div>
                </div>
              </div>
              <div class="flex items-center justify-between">
                <div>
                  <span class="font-medium text-gray-700">Status:</span>
                  <span
                    [class]="
                      'ml-1 px-2 py-1 text-xs font-semibold rounded-full ' +
                      getPostStatusClass(selectedFlaggedPostForModal)
                    "
                  >
                    {{ getPostStatusText(selectedFlaggedPostForModal) }}
                  </span>
                </div>
                <div>
                  <span class="font-medium text-gray-700">Severity:</span>
                  <span
                    [class]="
                      'ml-1 px-2 py-1 text-xs font-semibold rounded-full ' +
                      getReportSeverityClass(selectedFlaggedPostForModal)
                    "
                  >
                    {{ getReportSeverity(selectedFlaggedPostForModal) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Review Notes -->
          <div class="bg-blue-50 rounded-lg p-3 mb-4">
            <h3 class="text-sm font-semibold text-gray-800 mb-2">
              Review Notes
            </h3>
            <textarea
              [(ngModel)]="reviewNotes"
              placeholder="Add your review comments..."
              class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical min-h-[80px] text-sm"
              rows="3"
            ></textarea>
          </div>
          <!-- Individual Flags -->
          <div class="mb-4">
            <h3 class="text-sm font-semibold text-gray-800 mb-3">
              Reported Flags ({{
                selectedFlaggedPostForModal.postReports?.length || 0
              }})
            </h3>
            <div
              *ngIf="
                selectedFlaggedPostForModal.postReports &&
                  selectedFlaggedPostForModal.postReports.length > 0;
                else noIndividualFlags
              "
              class="space-y-3"
            >
              <div
                *ngFor="
                  let report of selectedFlaggedPostForModal.postReports;
                  trackBy: trackByReportId
                "
                class="bg-white border border-gray-200 rounded-lg p-3"
              >
                <div class="flex justify-between items-start mb-2">
                  <div class="flex-1">
                    <div class="text-xs text-gray-500 mb-1">
                      ID: {{ report.reportId.split("-")[0] }}
                    </div>
                    <div class="flex items-center gap-2 mb-1">
                      <span
                        [class]="
                          'px-2 py-1 text-xs font-semibold rounded-full ' +
                          getReportReasonClass(report.reportReason)
                        "
                      >
                        {{ report.reportReason }}
                      </span>
                      <span
                        [class]="
                          'px-2 py-1 text-xs font-semibold rounded-full ' +
                          getReportSeverityClassForReport(report)
                        "
                      >
                        {{ getReportSeverityForReport(report) }}
                      </span>
                    </div>
                  </div>
                  <span
                    [class]="
                      'px-2 py-1 text-xs font-semibold rounded-full ' +
                      getReportStatusClass(report.reportStatus)
                    "
                  >
                    {{ report.reportStatus }}
                  </span>
                </div>
                <div class="grid grid-cols-2 gap-2 text-xs text-gray-600 mb-2">
                  <div>
                    <span class="font-medium">Reported by:</span>
                    <div
                      class="text-blue-600 hover:underline cursor-pointer"
                      (click)="viewReporterProfile(report.reportedBy)"
                    >
                      {{ report.reportedByName }}
                    </div>
                  </div>
                  <div>
                    <span class="font-medium">Date:</span>
                    <div>{{ formatDate(report.reportDate) }}</div>
                  </div>
                </div>
                <div class="flex gap-2">
                  <button
                    *ngIf="
                      (report.reportStatus | lowercase) ===
                        ReportStatus.PENDING ||
                      report.reportStatus === ReportStatus.REVIEWED
                    "
                    (click)="
                      resolveReport(
                        selectedFlaggedPostForModal,
                        report.reportId
                      )
                    "
                    class="flex-1 text-green-600 hover:text-green-900 text-xs px-2 py-1 rounded hover:bg-green-50 border border-green-200"
                  >
                    Resolve
                  </button>
                  <button
                    *ngIf="
                      report.reportStatus === ReportStatus.PENDING ||
                      report.reportStatus === ReportStatus.REVIEWED
                    "
                    (click)="
                      dismissReport(
                        selectedFlaggedPostForModal,
                        report.reportId
                      )
                    "
                    class="flex-1 text-gray-600 hover:text-gray-900 text-xs px-2 py-1 rounded hover:bg-gray-50 border border-gray-200"
                  >
                    Dismiss
                  </button>
                  <button
                    *ngIf="report.reportStatus === ReportStatus.PENDING"
                    class="flex-1 text-blue-600 hover:text-blue-900 text-xs px-2 py-1 rounded hover:bg-blue-50 border border-blue-200"
                  >
                    Review
                  </button>
                </div>
              </div>
            </div>
            <ng-template #noIndividualFlags>
              <div class="text-center py-6 text-gray-500">
                <mat-icon class="text-3xl mb-2">report_off</mat-icon>
                <p class="text-sm">No individual flags found</p>
              </div>
            </ng-template>
          </div>
          <!-- Mobile Action Buttons -->
          <div class="px-4 py-3 border-t bg-gray-50 rounded-b-xl">
            <div class="grid grid-cols-2 gap-2 mb-2">
              <button
                (click)="removePost(selectedFlaggedPostForModal)"
                class="px-4 py-2 bg-red-600 text-white text-sm rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition-all duration-200"
              >
                Remove Post
              </button>
              <button
                (click)="clearAllFlags(selectedFlaggedPostForModal)"
                class="px-4 py-2 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 transition-all duration-200"
              >
                Clear Flags
              </button>
            </div>
          </div>
        </div>
        <!-- Mobile Action Buttons -->
        <div class="px-4 py-3 border-t bg-gray-50 rounded-b-xl">
          <div class="grid grid-cols-2 gap-2 mb-2">
            <button
              (click)="removePost(selectedFlaggedPostForModal)"
              class="px-4 py-2 bg-red-600 text-white text-sm rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 transition-all duration-200"
            >
              Remove Post
            </button>
            <button
              (click)="clearAllFlags(selectedFlaggedPostForModal)"
              class="px-4 py-2 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 transition-all duration-200"
            >
              Clear Flags
            </button>
          </div>
        </div>
      </div>
      <!-- Desktop Modal -->
      <div
        class="hidden sm:block relative bg-white rounded-lg shadow-xl w-full max-w-4xl mx-auto p-6 sm:p-8 transform transition-all duration-300 max-h-[90vh] overflow-hidden"
        style="font-family: 'Inter', sans-serif"
        (click)="$event.stopPropagation()"
      >
        <div class="flex justify-between items-center border-b pb-4 mb-4">
          <h2 class="text-xl sm:text-2xl font-bold text-gray-800">
            Manage Flagged Post
            {{ selectedFlaggedPostForModal.postId.split("-")[0] }}
          </h2>
          <button
            (click)="closeFlaggedPostModal()"
            class="text-gray-500 hover:text-gray-700 transition-colors duration-200"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="overflow-y-auto" style="max-height: calc(90vh - 200px)">
          <!-- Post Details Section -->
          <div class="space-y-4 mb-6">
            <h3 class="text-lg font-semibold text-gray-800">Post Details</h3>
            <div
              class="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4 text-gray-700 text-sm sm:text-base"
            >
              <div>
                <span class="font-semibold">Content:</span>
                <span class="whitespace-pre-wrap break-words">{{
                  selectedFlaggedPostForModal.postDescription
                }}</span>
              </div>
              <div>
                <span class="font-semibold">Author:</span>
                {{ selectedFlaggedPostForModal.postUsername }} ({{
                  getUserRole(selectedFlaggedPostForModal.postUserId)
                }})
              </div>
              <div>
                <span class="font-semibold">Submitted On:</span>
                {{ formatDate(selectedFlaggedPostForModal.postAddDate) }}
              </div>
              <div>
                <span class="font-semibold">Current Post Status:</span>
                <span
                  [class]="
                    'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                    getPostStatusClass(selectedFlaggedPostForModal)
                  "
                >
                  {{ getPostStatusText(selectedFlaggedPostForModal) }}
                </span>
              </div>
              <div>
                <span class="font-semibold">Total Flags:</span>
                {{ selectedFlaggedPostForModal.postReports?.length || 0 }}
              </div>
              <div>
                <span class="font-semibold">Highest Severity:</span>
                <span
                  [class]="
                    'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                    getReportSeverityClass(selectedFlaggedPostForModal)
                  "
                >
                  {{ getReportSeverity(selectedFlaggedPostForModal) }}
                </span>
              </div>
            </div>
          </div>
          <!-- Review Comments/Notes Section -->
          <div class="bg-blue-50 rounded-lg p-4 mb-6">
            <h3 class="text-lg font-semibold text-gray-800 mb-3">
              Review Notes
            </h3>
            <div class="space-y-3">
              <textarea
                [(ngModel)]="reviewNotes"
                placeholder="Add your review comments or notes about this flagged post..."
                class="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical min-h-[100px]"
                rows="3"
              ></textarea>
            </div>
          </div>
          <!-- Individual Flags Section -->
          <div
            *ngIf="
              selectedFlaggedPostForModal.postReports &&
                selectedFlaggedPostForModal.postReports.length > 0;
              else noIndividualFlags
            "
          >
            <div class="overflow-x-auto">
              <table
                class="min-w-full bg-white rounded-lg shadow-sm border border-gray-200"
              >
                <thead class="bg-gray-50">
                  <tr>
                    <th class="px-3 py-2 text-left">
                      <input
                        type="checkbox"
                        [checked]="areAllFlagsSelected()"
                        [indeterminate]="isSomeFlagsSelected()"
                        (change)="toggleAllFlags($event)"
                        class="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                    </th>
                    <th
                      class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                    >
                      Report ID
                    </th>
                    <th
                      class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                    >
                      Reason
                    </th>
                    <th
                      class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                    >
                      Reported By
                    </th>
                    <th
                      class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                    >
                      Date
                    </th>
                    <th
                      class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                    >
                      Severity
                    </th>
                    <th
                      class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                    >
                      Status
                    </th>
                    <th
                      class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  <tr
                    *ngFor="
                      let report of selectedFlaggedPostForModal.postReports;
                      trackBy: trackByReportId
                    "
                    [class.bg-blue-50]="isReportSelected(report.reportId)"
                  >
                    <td class="px-3 py-2">
                      <input
                        type="checkbox"
                        [checked]="isReportSelected(report.reportId)"
                        (change)="
                          toggleReportSelection(report.reportId, $event)
                        "
                        class="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                    </td>
                    <td class="px-3 py-2 text-xs text-gray-900">
                      {{ report.reportId.split("-")[0] }}
                    </td>
                    <td class="px-3 py-2 text-xs">
                      <span
                        [class]="
                          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                          getReportReasonClass(report.reportReason)
                        "
                      >
                        {{ report.reportReason }}
                      </span>
                    </td>
                    <td
                      class="px-3 py-2 text-xs text-blue-600 hover:underline cursor-pointer"
                      (click)="viewReporterProfile(report.reportedBy)"
                    >
                      {{ report.reportedByName }}
                    </td>
                    <td class="px-3 py-2 text-xs text-gray-600">
                      {{ formatDate(report.reportDate) }}
                    </td>
                    <td class="px-3 py-2 text-xs">
                      <span
                        [class]="
                          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                          getReportSeverityClassForReport(report)
                        "
                      >
                        {{ getReportSeverityForReport(report) }}
                      </span>
                    </td>
                    <td class="px-3 py-2 text-xs">
                      <span
                        [class]="
                          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full ' +
                          getReportStatusClass(report.reportStatus)
                        "
                      >
                        {{ report.reportStatus }}
                      </span>
                    </td>
                    <td class="px-3 py-2 text-xs font-medium">
                      <div class="flex flex-wrap gap-1">
                        <button
                          *ngIf="
                            (report.reportStatus | lowercase) ===
                              ReportStatus.PENDING ||
                            report.reportStatus === ReportStatus.REVIEWED
                          "
                          (click)="
                            resolveReport(
                              selectedFlaggedPostForModal,
                              report.reportId
                            )
                          "
                          class="text-green-600 hover:text-green-900 text-xs px-1 py-0.5 rounded hover:bg-green-50"
                        >
                          Resolve
                        </button>
                        <button
                          *ngIf="
                            report.reportStatus === ReportStatus.PENDING ||
                            report.reportStatus === ReportStatus.REVIEWED
                          "
                          (click)="
                            dismissReport(
                              selectedFlaggedPostForModal,
                              report.reportId
                            )
                          "
                          class="text-gray-600 hover:text-gray-900 text-xs px-1 py-0.5 rounded hover:bg-gray-50"
                        >
                          Dismiss
                        </button>
                        <button
                          *ngIf="report.reportStatus === ReportStatus.PENDING"
                          class="text-blue-600 hover:text-blue-900 text-xs px-1 py-0.5 rounded hover:bg-blue-50"
                        >
                          Review
                        </button>
                        <span
                          *ngIf="
                            report.reportStatus === ReportStatus.RESOLVED ||
                            report.reportStatus === ReportStatus.DISMISSED ||
                            report.reportStatus === ReportStatus.BANNED
                          "
                          class="text-gray-500 text-xs"
                        >
                          Complete
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <ng-template #noIndividualFlags>
            <div class="text-center py-8 text-gray-500">
              <mat-icon class="text-4xl mb-2">report_off</mat-icon>
              <p>No individual flags found for this post.</p>
            </div>
          </ng-template>
        </div>
        <!-- Desktop Action Buttons -->
        <div
          class="mt-6 flex flex-col sm:flex-row justify-end gap-3 border-t pt-4"
        >
          <button
            (click)="removePost(selectedFlaggedPostForModal)"
            class="w-full sm:w-auto px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 transition-all duration-200"
          >
            Remove Post
          </button>
          <!-- <button
            (click)="ignoreFlags(selectedFlaggedPostForModal)"
            class="w-full sm:w-auto px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 transition-all duration-200"
          >
            Ignore Flag
          </button> -->
          <button
            (click)="clearAllFlags(selectedFlaggedPostForModal)"
            class="w-full sm:w-auto px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 transition-all duration-200"
          >
            Clear All Flags
          </button>
          <button
            (click)="closeFlaggedPostModal()"
            class="w-full sm:w-auto px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50 transition-all duration-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="activeSection === 'analytics'">
      <h3 class="text-lg sm:text-xl font-semibold text-gray-800 mb-4">
        Analytics & Performance
      </h3>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-4">
        <div
          class="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-gray-200"
        >
          <p class="text-xs sm:text-sm font-medium text-gray-600">
            Approval Rate
          </p>
          <p class="text-xl sm:text-2xl font-bold text-green-600">
            {{ getApprovalRate() }}%
          </p>
        </div>
        <div
          class="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-gray-200"
        >
          <p class="text-xs sm:text-sm font-medium text-gray-600">
            Rejection Rate
          </p>
          <p class="text-xl sm:text-2xl font-bold text-red-600">
            {{ getRejectionRate() }}%
          </p>
        </div>
        <div
          class="bg-white p-3 sm:p-4 rounded-lg shadow-sm border border-gray-200"
        >
          <p class="text-xs sm:text-sm font-medium text-gray-600">
            Avg. Post Review Time
          </p>
          <p class="text-xl sm:text-2xl font-bold text-blue-600">
            {{ getAvgReviewTime() }}
          </p>
        </div>
      </div>

      <div class="mt-6 sm:mt-8">
        <h4
          class="text-base sm:text-lg font-semibold text-gray-800 mb-2 sm:mb-3"
        >
          Post Status Distribution
        </h4>
        <div
          class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 bg-gray-50 p-4 rounded-lg shadow-sm"
        >
          <div class="text-center min-w-[120px]">
            <p class="text-3xl sm:text-4xl font-bold text-yellow-600">
              {{ pendingApprovalPosts.length }}
            </p>
            <p class="text-sm text-gray-600">Pending</p>
          </div>
          <div class="text-center min-w-[120px]">
            <p class="text-3xl sm:text-4xl font-bold text-green-600">
              {{ approvedPosts.length }}
            </p>
            <p class="text-sm text-gray-600">Approved</p>
          </div>
          <div class="text-center min-w-[120px]">
            <p class="text-3xl sm:text-4xl font-bold text-red-600">
              {{ rejectedPosts.length }}
            </p>
            <p class="text-sm text-gray-600">Rejected</p>
          </div>
          <div class="text-center min-w-[120px]">
            <p class="text-3xl sm:text-4xl font-bold text-orange-600">
              {{ flaggedPosts.length }}
            </p>
            <p class="text-sm text-gray-600">Flagged</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
